module.exports = __webpack_public_path__ + "static/img/hmv.2a811e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ribenurl/hmv.jpg
// module id = gURz
// module chunks = 23